import { ConfigState, EmpathyXConfig } from '../../../models';
import { CONFIG_GETTERS_KEYS } from '../../config/config.const';
import { ConfigGetter } from '../config.interfaces';

export class PreFacetsGetter implements ConfigGetter {
  getters = {
    [CONFIG_GETTERS_KEYS.preFacets]: (configState: ConfigState, getters: any): string[] => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      const preFacets = config.preFacets;
      const searchLang = configState.dynamic.searchLang;
      return preFacets[searchLang] ?? [];
    }
  };
}
